import React, { useState, useRef } from 'react'
import Button from '../../../../Button/Button';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddButton from '../../../../AddButton/AddButton';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import closeIcon from "../../../../../Assets/close-icon.svg"
import Loader from '../../../../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { SET_MODAL } from '../../../../../redux/actionTypes/modalActionType';
import { serviceConsumer } from '../../../../../network/ServiceConsumer';
import { handlePhotoUpload } from '../../../../../helper/handleUploads';
import { openSelectOldCollabModal } from '../../../../../helper/openSelectOldCollabModal';
import { ShowToastMessage } from '../../../../../helper/ShowToastMessage';
import { accountRegions } from '../../../../../helper/DataArrays';

// manageType: as CollaboratorModal ("feis" = /people routes, which also serve
// Oireachtas events; default = the feis/grade manage screen's localStorage flag)
const AddCollaboratorModal = ({ modalState, title, btnName, manageType }) => {
    const [loading, setLoading] = useState(false)
    const [imgErr, setImgErr] = useState("");
    const [logo, setLogo] = useState("");
    const [upl, setUpl] = useState("");
    const [err, setErr] = useState("")
    const fileInputRef = useRef()
    const dispatch = useDispatch();
    const modal = useSelector((state) => state.modalReducer)
    const eventId = modal.eventId
    const ManageType = manageType || localStorage.getItem('Manage');

    //Initial values for formik
    const addCollaboratorInitialValues = {
        fname: "",
        lname: "",
        location: "",
        email: "",
        region: "",
    };
    // every judge's first booking sends their account invitation (card
    // 930d3ac0, Devin 2026-10-26), so a new adjudicator needs an email
    const isAdjudicator = btnName === "adjudicator";
    const getCollabName = () => {
        if (btnName === "adjudicator") return "adjudicator"
        else if (btnName === "musician") return "musician"
        else if (btnName === "Examiner") return "examiner"
        else return "sponsor"
    }
    //Validation Schema for Formik
    const addCollaboratorValidationSchema = Yup.object().shape({
        email: isAdjudicator
            ? Yup.string().trim().email("Enter a valid email address.").required("This field is required.")
            : Yup.string(),
        fname: Yup.string()
            .trim()
            .label("fname")
            .required("This field is required.")
            .nullable()
            .max(30, "Maximum characters allowed 30"),
        lname: Yup.string()
            .trim()
            .label("lname")
            .required("This field is required.")
            .nullable()
            .max(30, "Maximum characters allowed 30"),
        // a new adjudicator isn't in the CLRG directory: admin sets the region,
        // and the place shown comes from it (no Location box; Devin 2026-10-27)
        ...(isAdjudicator
            ? { region: Yup.string().required("Choose a region.") }
            : {
                location: Yup.string()
                    .trim()
                    .label("lname")
                    .required("This field is required.")
                    .nullable()
                    .max(30, "Maximum characters allowed 30"),
            }),
    });

    //form submit handler-to add collaborator
    const addCollaboratorHandler = async (values) => {
        setLoading(true)
        const payload = {
            fname: values.fname,
            lname: values.lname,
            ...(isAdjudicator ? { region: values.region } : { location: values.location }),
            type: btnName,
            photo: logo,
            eventId: eventId,
            ...(isAdjudicator ? { email: values.email.trim() } : {}),
        }
        const collaborator = getCollabName()

        try {
            const feisUrl = `${process.env.REACT_APP_BASE_URL}/people/${collaborator}`;
            const gradeUrl = `${process.env.REACT_APP_BASE_URL}/grade-exam/${collaborator}`;
            const url = ManageType === "feis" ? feisUrl : gradeUrl
            const response = await serviceConsumer("POST", url, payload)
            // only a saved booking is confirmed (the API can answer success: false)
            if (response?.success !== true) {
                setLoading(false)
                setErr(response?.message || "That wasn't added. Please try again.")
                return
            }
            if (response.inviteError) ShowToastMessage("error", `Added, but the invitation wasn't sent: ${response.inviteError}`, 4000)
            else if (isAdjudicator) ShowToastMessage("success", "Added, and their account invitation is on its way.", 3000)
            openCollaboratorModal()
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            setErr(error.messages)
        }
    }

    //add image on button click with input hidden //since input is hidden, point it with button click
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const handleFileSelect = async (event) => {
        handlePhotoUpload(event, setLoading, setLogo, setUpl, setImgErr);
    };


    //on close modal, open previous modal
    const modalCloseHandler = () => openSelectOldCollabModal(title, eventId, "Sponsor", dispatch)

    //on submit, open collaborator modal
    const openCollaboratorModal = () => {
        dispatch({
            type: SET_MODAL,
            payload: {
                modal: `${title}s`,
                eventId: eventId,
            }
        })
    }

    return (
        <div>
            {loading && <Loader />}
            <Modal className="addDancerScroll" sx={{ display: "flex", alignItems: "center", justifyContent: "center", }} open={modalState}>
                <Box className="mui-box">
                    <div className='modal-box'>
                        <div className="org-modal-div">
                            <div className="close-div mt-4 mb-1">
                                <img src={closeIcon} alt="close-icon" className="close-icon" onClick={modalCloseHandler} />
                            </div>
                            <p className="color-subtitle text-center mb-4">Add {title}</p>
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ background: "white,borderRadius: 14px;" }}
                            >
                                <div>
                                    <Formik
                                        initialValues={addCollaboratorInitialValues}
                                        validationSchema={addCollaboratorValidationSchema}
                                        onSubmit={addCollaboratorHandler}
                                    >
                                        {({ dirty, isValid }) => {
                                            return (
                                                <Form autoComplete="off">
                                                    <div>
                                                        <div className="d-flex flex-column">
                                                            <label className="label-head">First name:</label>
                                                            <Field className="input-box" type="text" name="fname" placeholder="Name" maxlength={30} />
                                                            <ErrorMessage className="auth-error" name="fname" component="div" />
                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <label className="label-head">Last name:</label>
                                                            <Field className="input-box" type="text" name="lname" placeholder="Name" maxlength={30} />
                                                            <ErrorMessage className="auth-error" name="lname" component="div" />
                                                        </div>
                                                        {isAdjudicator ? (
                                                            <div className="d-flex flex-column">
                                                                <label className="label-head">Region:</label>
                                                                <Field as="select" className="input-box" name="region">
                                                                    <option value="" disabled>Select a region</option>
                                                                    {accountRegions.map((r) => <option key={r.value} value={r.value}>{r.key}</option>)}
                                                                </Field>
                                                                <ErrorMessage className="auth-error" name="region" component="div" />
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex flex-column">
                                                                <label className="label-head">Location:</label>
                                                                <Field className="input-box" type="text" name="location" placeholder="Location" maxlength={30} />
                                                                <ErrorMessage className="auth-error" name="location" component="div" />
                                                            </div>
                                                        )}
                                                        {isAdjudicator && (
                                                            <div className="d-flex flex-column">
                                                                <label className="label-head">Email:</label>
                                                                <Field className="input-box" type="email" name="email" placeholder="name@example.com" />
                                                                <ErrorMessage className="auth-error" name="email" component="div" />
                                                                <p style={{ maxWidth: 248, fontSize: 12, color: "#797979", margin: "4px 0 8px" }}>
                                                                    We'll email them an invitation to set up their Feis.link adjudicator account.
                                                                </p>
                                                            </div>
                                                        )}
                                                        <div className="label-head">Photo:</div>
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef}
                                                            accept="image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileSelect}
                                                        />
                                                        <div className="remove-margin">
                                                            <AddButton className="plusIconbtn" onClick={handleButtonClick} style={{ marginTop: "0" }}>Add Photo</AddButton>
                                                        </div>
                                                        {imgErr && <div className="error mt-2" style={{ width: "248px" }}>{imgErr}</div>}
                                                        {upl && <div className="auth-suc" style={{ width: "248px" }}>{upl}</div>}
                                                        {!loading && err && (<div style={{ color: 'red', textAlign: "center" }}> {err}</div>)}
                                                        <div className="d-flex justify-content-center mt-3 mb-5" >
                                                            <Button type="submit" className={isValid && dirty ? "filled " : "disabled "}>Add {btnName}</Button>
                                                        </div>
                                                    </div>
                                                </Form>
                                            );
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div >
    )
}

export default AddCollaboratorModal